const KEY_PREFIX = 'noviSecretLink_';
const TTL_MS = 7 * 24 * 60 * 60 * 1000;

interface SecretLinkGrant {
    expiresAt: number;
}

class SecretLinkStorageMethods {
    save(memberTypeId: number): void {
        if (!this.isValidMemberTypeId(memberTypeId)) {
            return;
        }

        try {
            const grant: SecretLinkGrant = { expiresAt: Date.now() + TTL_MS };
            localStorage.setItem(this.storageKey(memberTypeId), JSON.stringify(grant));
        } catch {
            // Private mode / quota — grant stays in-memory for this page only.
        }
    }

    hasValidGrant(memberTypeId: number): boolean {
        if (!this.isValidMemberTypeId(memberTypeId)) {
            return false;
        }

        try {
            const raw = localStorage.getItem(this.storageKey(memberTypeId));
            if (!raw) {
                return false;
            }

            const grant = JSON.parse(raw) as SecretLinkGrant;
            if (!grant || typeof grant.expiresAt !== 'number' || grant.expiresAt <= Date.now()) {
                this.clear(memberTypeId);
                return false;
            }

            return true;
        } catch {
            return false;
        }
    }

    clear(memberTypeId: number): void {
        if (!this.isValidMemberTypeId(memberTypeId)) {
            return;
        }

        try {
            localStorage.removeItem(this.storageKey(memberTypeId));
        } catch {
            // Ignore storage failures.
        }
    }

    resolve(memberTypeId: number, isSecretLinkFromUrl: boolean): boolean {
        if (isSecretLinkFromUrl) {
            this.save(memberTypeId);
            return this.isValidMemberTypeId(memberTypeId);
        }

        return this.hasValidGrant(memberTypeId);
    }

    private storageKey(memberTypeId: number): string {
        return `${KEY_PREFIX}${memberTypeId}`;
    }

    private isValidMemberTypeId(memberTypeId: number): boolean {
        return typeof memberTypeId === 'number' && isFinite(memberTypeId) && memberTypeId > 0;
    }
}

const SecretLinkStorage = new SecretLinkStorageMethods();
export default SecretLinkStorage;
